import {LauncherServiceBase} from '../launcher-service-base';
import {ILauncherServiceFactory} from '../launcher-service-factory.interface';
import {EnvironmentPreset} from './environment-preset';
import {IPresetsService, PresetsBatch} from './presets.service.interface';
import {IPreset} from './preset.interface';

export class PresetsService extends LauncherServiceBase implements IPresetsService {
    constructor(services: ILauncherServiceFactory) {
        super(services);
        this.presetsCategories = [
            {title: 'ENVIRONMENT PRESETS', presets: this._createEnvironmentsPresets()},
            {title: 'REGULATION PRESETS', presets: this._createRegulationPresets()}
        ];
    }

    presetsCategories: PresetsBatch[] = [];


    private _createRegulationPresets(): IPreset[] {
        let presets: IPreset[] = []
        this.services.regulations.items.forEach(regulation => {
            regulation.getPresets().forEach(preset => presets.push(preset));
        });

        return presets;
    }

    private _createEnvironmentsPresets(): EnvironmentPreset[] {
        return [
            new EnvironmentPreset('DEFAULT', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: undefined
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: undefined
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: undefined
                }
            ]),
            new EnvironmentPreset('DEV', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'http://localhost:83'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'http://localhost:7070'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'http://localhost:7070'
                }
            ]),
            new EnvironmentPreset('MIRAGE', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'http://mirage-cgp-latest-eu.888casino.com'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'http://mirage-cgp-latest-eu.888casino.com'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'http://mirage-cgp-latest-eu.888casino.com'
                }
            ]),
            new EnvironmentPreset('USQA', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'http://usqa-cgp-latest-us.888casino.com'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'http://usqa-cgp-latest-us.888casino.com'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'http://usqa-cgp-latest-us.888casino.com'
                }
            ]),
            new EnvironmentPreset('MGM', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'http://mgm-cgp-latest-eu.888casino.com'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'http://mgm-cgp-latest-eu.888casino.com'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'http://mgm-cgp-latest-eu.888casino.com'
                }
            ]),
            new EnvironmentPreset('NJPE_STAGE', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'https://cgp-stg-nj.secured-qa.com'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'https://cgp-stg-nj.secured-qa.com'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'https://cgp-stg-nj.secured-qa.com'
                }
            ]),
            new EnvironmentPreset('NJPE_Certification', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'https://cgp-nj.secured-qa.com'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'https://cgp-nj.secured-qa.com'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'https://cgp-nj.secured-qa.com'
                }
            ]),
            new EnvironmentPreset('USA_Stage', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'https://cgp-stg-nj.secured-igaming-services.com'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'https://cgp-stg-nj.secured-igaming-services.com'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'https://cgp-stg-nj.secured-igaming-services.com'
                }
            ]),
            new EnvironmentPreset('USA_Production', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'https://cgp-nj.secured-igaming-services.com'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'https://cgp-nj.secured-igaming-services.com'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'https://cgp-nj.secured-igaming-services.com'
                }
            ]),
            new EnvironmentPreset('EU_Stage', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'https://cgp-stage.safe-iplay.com'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'https://cgp-stage-cdn2.safe-iplay.com'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'https://cgp-stage-cdn2.safe-iplay.com'
                }
            ]),
            new EnvironmentPreset('EU_Production', [
                {
                    field: this.services.configurationsAreas.sdk.api,
                    value: 'https://cgp.safe-iplay.com'
                },
                {
                    field: this.services.configurationsAreas.sdk.server,
                    value: 'https://cgp-cdn2.safe-iplay.com'
                },
                {
                    field: this.services.configurationsAreas.orbit.server,
                    value: 'https://cgp-cdn2.safe-iplay.com'
                }
            ])
        ];
    }



}